import { ActionType } from '../types';
import { Types } from './actions';

const initialState = {
  loading: undefined,
  success: undefined,
  error: undefined,
};

const reducer = (state = initialState, action: ActionType) => {
  const { type } = action;
  switch (type) {
    case Types.LOGOUT_REQUEST: {
      return {
        success: undefined,
        error: undefined,
        loading: true,
      };
    }
    case Types.LOGOUT_SUCCESS: {
      return {
        success: true,
        loading: false,
        error: undefined,
      };
    }
    case Types.LOGOUT_FAILURE: {
      return {
        error: action.payload,
        success: false,
        loading: false,
      };
    }
    case Types.LOGOUT_ERROR: {
      return {
        error: action.payload,
        success: false,
        loading: false,
      };
    }
    default:
      return state;
  }
};

export default reducer;
